export const translations = {
  en: {
    // Header
    appName: 'SneakGuessr',
    round: 'Round',
    score: 'Score',

    // Game
    guessPrice: 'Guess the resale price',
    validate: 'Submit',
    nextSneaker: 'Next Sneaker',
    viewFinalScore: 'View Final Score',

    // Details
    colorway: 'Colorway',
    reference: 'Reference',

    // Results
    points: 'points',
    yourAnswer: 'Your Answer',
    actualPrice: 'Actual Price',
    difference: 'Difference',

    // Feedback messages
    perfect: 'Perfect!',
    excellent: 'Excellent!',
    veryGood: 'Very good!',
    good: 'Good guess!',
    notBad: 'Not bad!',
    couldBeBetter: 'Could be better!',
    farOff: 'Way off!',

    // Game Over
    gameOver: 'Game Over',
    outOf: 'out of',
    playAgain: 'Play Again',

    // Loading & Errors
    loading: 'Loading...',
    noSneakerAvailable: 'No sneaker available',
    noImageAvailable: 'Image not available',

    // Affiliate
    buyThisSneaker: 'Buy this sneaker',
    viewOnStockX: 'View on StockX',
    affiliateDisclaimer: 'Affiliate links - By purchasing through these links, you support SneakGuessr',

    // Landing
    landingEyebrow: '10 rounds · real resale prices',
    landingTitle1: 'Guess the price.',
    landingTitle2: 'Flex the score.',
    landingSubtitle: 'Can you tell a $90 pair from a $900 grail? Spot the sneaker, guess its resale price, and climb the ranks.',
    play: 'Play',
    step1Title: 'Spot the pair',
    step1Text: 'A random sneaker lands on screen.',
    step2Title: 'Guess the price',
    step2Text: 'Type what you think it resells for.',
    step3Title: 'Score up to 10,000',
    step3Text: 'The closer you are, the more points.',

    // Game extras
    roundOf: 'Round',
    clear: 'Clear',
    retry: 'Try again',
    you: 'You',

    // Final
    yourRank: 'Your rank',
    recap: 'Your 10 sneakers',
    share: 'Share my score',
    copied: 'Copied!',
    rank1: 'Resell Legend',
    rank2: 'Sneakerhead',
    rank3: 'Resell Rookie',
    rank4: 'Window Shopper',
    rank5: 'Just Browsing',

    // Legal
    legalNotice: 'Legal notice',
  },
  fr: {
    // Header
    appName: 'SneakGuessr',
    round: 'Round',
    score: 'Score',

    // Game
    guessPrice: 'Devinez le prix de revente',
    validate: 'Valider',
    nextSneaker: 'Sneaker suivante',
    viewFinalScore: 'Voir le score final',

    // Details
    colorway: 'Coloris',
    reference: 'Référence',

    // Results
    points: 'points',
    yourAnswer: 'Votre réponse',
    actualPrice: 'Prix réel',
    difference: 'Différence',

    // Feedback messages
    perfect: 'Parfait !',
    excellent: 'Excellent !',
    veryGood: 'Très bien !',
    good: 'Bonne estimation !',
    notBad: 'Pas mal !',
    couldBeBetter: 'Peut mieux faire !',
    farOff: 'Complètement à côté !',

    // Game Over
    gameOver: 'Partie terminée',
    outOf: 'sur',
    playAgain: 'Rejouer',

    // Loading & Errors
    loading: 'Chargement...',
    noSneakerAvailable: 'Aucune sneaker disponible',
    noImageAvailable: 'Image non disponible',

    // Affiliate
    buyThisSneaker: 'Acheter cette sneaker',
    viewOnStockX: 'Voir sur StockX',
    affiliateDisclaimer: 'Liens partenaires - En achetant via ces liens, vous soutenez SneakGuessr',

    // Landing
    landingEyebrow: '10 rounds · vrais prix de revente',
    landingTitle1: 'Devine le prix.',
    landingTitle2: 'Flex ton score.',
    landingSubtitle: 'Tu sais faire la différence entre une paire à 90 $ et un graal à 900 $ ? Repère la sneaker, devine son prix de revente et grimpe dans le classement.',
    play: 'Jouer',
    step1Title: 'Repère la paire',
    step1Text: "Une sneaker au hasard apparaît à l'écran.",
    step2Title: 'Devine le prix',
    step2Text: 'Saisis son prix de revente estimé.',
    step3Title: "Jusqu'à 10 000 points",
    step3Text: 'Plus tu es proche, plus tu marques.',

    // Game extras
    roundOf: 'Round',
    clear: 'Effacer',
    retry: 'Réessayer',
    you: 'Toi',

    // Final
    yourRank: 'Ton rang',
    recap: 'Tes 10 sneakers',
    share: 'Partager mon score',
    copied: 'Copié !',
    rank1: 'Légende du resell',
    rank2: 'Sneakerhead',
    rank3: 'Apprenti revendeur',
    rank4: 'Lèche-vitrine',
    rank5: 'Touriste',

    // Legal
    legalNotice: 'Mentions légales',
  }
} as const;

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en;
